import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'

// Modules
import user from './modules/user'
import page from './modules/page'
import subjects from './modules/subjects'
import chapters from './modules/chapters'
import lectureNotes from './modules/lecture-notes'
import microNotes from './modules/micro-notes'
import microNoteExporter from './modules/micro-note-exporter'
import studier from './modules/studier'
import ads from './modules/ads'
import courses from './modules/courses'
import blogs from './modules/blogs'
import comments from './modules/comments'
import userSearch from './modules/user-search'
import chapterSharer from './modules/chapter-sharing'
import notifications from './modules/notifications'
import userExporter from './modules/user-exporter'
import newsletterSubs from './modules/newsletter-subs'
import userActivityReport from './modules/user-activity-report'


Vue.use(Vuex)



export default new Vuex.Store({
  actions,
  getters,
  modules: {
    currentUser: user,
    studier,
    page,
    subjects,
    chapters,
    microNotes,
    microNoteExporter,
    lectureNotes,
    ads,
    courses,
    blogs,
    comments,
    userSearch,
    chapterSharer,
    notifications,
    userExporter,
    newsletterSubs,
    userActivityReport,
  },

  // In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown. This ensures that all state mutations can be explicitly tracked by debugging tools.
  strict: true,
  // strict: process.env.NODE_ENV !== 'production',
})








// WEBPACK FOOTER //
// ./src/store/index.js